import { selectVisibleInfraredFlights } from "features/entity-caching/flights/selectors"
import OrthoOverlapLayer from "features/map/layers/bitmap/ortho-overlap/OrthoOverlapLayer.class"
import { useAppSelector } from "integrations/redux/hooks"
import { useOrthoOverlap } from "plugins/shared/layers/ortho-overlap/useOrthoOverlap"
import { selectAllUploads } from "../InfraredImageSlice"

export const useIROverlapLayer = () => {
    const allUploadsById = useAppSelector(selectAllUploads())
    const flights = useAppSelector(selectVisibleInfraredFlights)
    const { overlapImages } = useOrthoOverlap({ allUploadsById, flights, type: "ir" })

    return new OrthoOverlapLayer({
        id: "IR-Ortho-Overlap",
        data: overlapImages,
    })
}
